import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import DataTable from "datatables.net-react";
import DT from "datatables.net-dt";
import { deleteSupportingContentItem } from "services/supportingContent";
import Swal from "sweetalert2";

DataTable.use(DT);

const ContentTable = ({ content, content_title = "content" }) => {
  const navigate = useNavigate();
  const tableRef = useRef(null);

  const findRowById = (id) => {
    if (tableRef.current) {
      const table = tableRef.current.dt();
      const row = table.row((idx, data) => data[0] === id);
      return row;
    }
  };

  window.edit = (id) => {
    console.log("!!! CONTENT EDIT: ", id, content);
    if (tableRef.current) {
      const activeContent = content.find((c) => c.public_id === id);
      console.log("!!! ACTIVE CONTENT: ", activeContent);

      if (!activeContent) {
        Swal.fire({
          title: "Error",
          text: "Content not found",
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }
      navigate(`/client/editor/${id}`);
    }
  };

  window.remove = (id) => {
    console.log("!!! CONTENT REMOVE: ", id);
    if (tableRef.current) {
      const row = findRowById(id);

      if (row) {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        }).then(async (result) => {
          console.log("!!! REMOVE: ", result);
          if (result.value) {
            console.log("!!! REMOVE: ", row);
            row.remove().draw();
            const response = await deleteSupportingContentItem(id);
            if (response.success) {
              Swal.fire("Deleted!", "The content has been deleted.", "success");
            } else {
              Swal.fire({
                title: "Error",
                text: response.error,
                icon: "error",
                confirmButtonText: "OK",
              });
            }
          }
        });
      }
    }
  };

  const tableData = content.map((content) => {
    return [
      content.public_id,
      `<div style="font-weight: 700">${content.name}</div>`,
      content.description,
      content.status ?? "Not reviewed",
      `<div style="display: flex; flex-direction: row;"><button onClick="edit('${content.public_id}')" class="bg-blueGray-500 text-white active:bg-blueGray-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">✎</button><button onClick="remove('${content.public_id}')" class="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">×</button></div>`,
    ];
  });

  return (
    <DataTable
      ref={tableRef}
      data={tableData}
      className="display"
      options={{
        responsive: true,
        select: true,
        pageLength: 25,
      }}
    >
      <thead>
        <tr>
          <th>ID</th>
          <th>Title</th>
          <th style={{ width: "500px" }}>Description</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
    </DataTable>
  );

  /*
  return (
    <DataTable
      title="Content"
      columns={columns}
      data={data}
      pagination
      highlightOnHover
    />
  );
    */
};

export default ContentTable;
